import React from 'react';
import {Switch} from '@mantine/core';
import useSwitchState, {ApiSwitchProps} from './state';
import Loading from '../loading';
import {Container} from './styles';

const ApiSwitch: React.FC<ApiSwitchProps> = (props) => {
  const {isLoading, handleRequest} = useSwitchState(props);

  return isLoading ? (
    <Container>
      <Loading />
    </Container>
  ) : (
    <Switch
      disabled={props.disabled}
      styles={(theme) => ({
        track: props.disabled
          ? {
              backgroundColor: theme.colors.blue[6],
              borderColor: theme.colors.blue[6],
              opacity: 1,
            }
          : undefined,
      })}
      onChange={(e) =>
        handleRequest(e.currentTarget.checked, props.field ?? 'active')
      }
      checked={props.isChecked}
    />
  );
};

export default ApiSwitch;
